import { Directive, inject, OnInit } from '@angular/core';
import {
  DvElementType,
  DvFormComponent,
  DvFormElementParams,
  DvFormSection,
  DvFormSectionsComponent,
} from '@devinco/ui/dds';
import { TranslateService } from '@ngx-translate/core';
import { ValidatorName } from '@shared/constants/validator-name';

@Directive({
  selector: '[vtFormTranslate]',
  standalone: true,
})
export class FormTranslationDirective implements OnInit {
  private dynamicForm = inject(DvFormComponent, { optional: true });
  private translate = inject(TranslateService);
  private formSections = inject(DvFormSectionsComponent, { optional: true });

  private validatorMessages = {
    [ValidatorName.Required]: 'Validation.Required',
    [ValidatorName.MinLength]: 'Validation.MinLength',
    [ValidatorName.MaxLength]: 'Validation.MaxLength',
    [ValidatorName.Email]: 'Validation.Email',
    [ValidatorName.Max]: 'Validation.Max',
    [ValidatorName.Min]: 'Validation.Min',
  };

  ngOnInit(): void {
    this.translateElements(this.dynamicForm?.elements() || []);
    this.translateSections(this.formSections?.formSections() || []);
  }

  private translateSections(sections: DvFormSection[]): void {
    sections.forEach(section => {
      section.title = section.title
        ? this.translate.instant(section.title)
        : undefined;
      this.translateElements(section.elements);
    });
  }

  private translateElements(params: DvFormElementParams[]): void {
    params.forEach(param => {
      switch (param.type) {
        case DvElementType.Checkbox: {
          this.translateCheckbox(param);
          break;
        }

        case DvElementType.Toggle: {
          this.translateSlideToggle(param);
          break;
        }
        case DvElementType.Button: {
          this.translateButton(param);
          break;
        }
      }

      if (param.labelText) {
        param.labelText = this.translate.instant(param.labelText);
      }

      if (param.labelTooltipIconText) {
        param.labelTooltipIconText = this.translate.instant(
          param.labelTooltipIconText
        );
      }

      param.formControlParams!.validationMessages = {
        ...this.validatorMessages,
        ...param.formControlParams!.validationMessages,
      };

      Object.keys(param.formControlParams!.validationMessages).forEach(key => {
        param.formControlParams!.validationMessages![key] =
          this.translate.instant(
            param.formControlParams!.validationMessages![key]
          );
      });
    });
  }

  private translateButton(button: DvFormElementParams): void {
    if (button.elementParams.text) {
      button.elementParams.text = this.translate.instant(
        button.elementParams.text
      );
    }
    if (button.elementParams.tooltip) {
      button.elementParams.tooltip = this.translate.instant(
        button.elementParams.tooltip
      );
    }
  }

  private translateSlideToggle(slideToggle: DvFormElementParams): void {
    if (slideToggle.labelText) {
      slideToggle.labelText = this.translate.instant(slideToggle.labelText);
    }
  }

  private translateCheckbox(checkbox: DvFormElementParams): void {
    if (checkbox.elementParams.checkboxLabel) {
      checkbox.elementParams.checkboxLabel = this.translate.instant(
        checkbox.elementParams.checkboxLabel
      );
    }
  }
}
